<ng-template #financialsContent>
  <div class="body">
    <h1>Lading Financials</h1>
    <!-- <button mat-raised-button (click)="openCarrierSpotQuoteModal()">Add Carrier Spot Quote</button> -->
    <button mat-raised-button (click)="sendCarrierConfirmationEmail(false)">Send Carrier Confirmation Email</button>
    <button mat-raised-button (click)="sendCarrierConfirmationEmail(true)">Send Carrier Confirmation as PDF</button>
    <button mat-stroked-button [matMenuTriggerFor]="addServicesMenu">Add Service</button>
    <mat-menu #addServicesMenu="matMenu">
        <button mat-menu-item (click)="addService(1, 'Freight')">Freight Cost</button>
        <button mat-menu-item (click)="addService(2, 'Freight')">Freight Charge</button>
        <button mat-menu-item (click)="addService(1, 'Fuel Surcharge')">FSC Cost</button>
        <button mat-menu-item (click)="addService(2, 'Fuel Surcharge')">FSC Charge</button>
        <button mat-menu-item (click)="addService()">Manual Service</button>
    </mat-menu>

    <div *ngIf="!autorater_needed">

    <button mat-raised-button (click)="sendEDIFile()" *ngIf="edi_customer">Send EDI File</button>

        <mat-card>
            <mat-card-header>
            <mat-card-title>All Lading Financials</mat-card-title>
            </mat-card-header>
            <mat-card-content>
            <mat-tab-group>
                <mat-tab
                *ngFor="let lading of lading_financials_list; let i = index"
                [label]="lading.alternate_reference">

                <!-- maybe we can aadd a per-tab collapse toggle -->
                <!-- <div style="display: flex; align-items: center; margin-bottom: 8px;">
                    <button
                    mat-icon-button
                    (click)="ladingCollapsed[i] = !ladingCollapsed[i]">
                    <mat-icon>
                        {{ ladingCollapsed[i] ? 'chevron_right' : 'chevron_left' }}
                    </mat-icon>
                    </button>
                    <span style="margin-left: 8px;">
                    {{ ladingCollapsed[i] ? 'Expand' : 'Collapse' }} Details
                    </span>
                </div> -->

                <!-- inner tabs only when expanded -->
                <mat-tab-group
                    *ngIf="!ladingCollapsed[i]"
                    dynamicHeight
                    style="margin-top: 16px;">
                    
                    <mat-tab label="Costs">
                    <div class="table-container">
                        <ag-grid-angular
                        class="ag-theme-ulaap"
                        style="width: 100%;"
                        domLayout="autoHeight"
                        [rowData]="lading.financials.costs.line_items"
                        [columnDefs]="financialsColumnDefs"
                        [pinnedBottomRowData]="getPinnedBottomRowDataFor(lading, 'costs')"
                        enableRowPinning
                        (cellValueChanged)="onCostCellValueChanged($event)"
                        (gridReady)="onGridReady($event)"
                        (gridSizeChanged)="onGridSizeChanged($event)">
                        </ag-grid-angular>
                    </div>
                    </mat-tab>

                    <mat-tab label="Chargeables">
                    <div class="table-container">
                        <ag-grid-angular
                        class="ag-theme-ulaap"
                        style="width: 100%;"
                        domLayout="autoHeight"
                        [rowData]="lading.financials.chargeables.line_items"
                        [columnDefs]="financialsColumnDefs"
                        [pinnedBottomRowData]="getPinnedBottomRowDataFor(lading, 'chargeables')"
                        enableRowPinning
                        (cellValueChanged)="onChargeableCellValueChanged($event)"
                        (gridReady)="onGridReady($event)"
                        (gridSizeChanged)="onGridSizeChanged($event)">
                        </ag-grid-angular>
                    </div>
                    </mat-tab>

                </mat-tab-group>
                </mat-tab>
            </mat-tab-group>
            </mat-card-content>
        </mat-card>
        </div> <!-- end *ngIf="!autorater_needed" -->

        <div *ngIf="productBreakdown.length > 0">
            <mat-card>
                <mat-card-header>
                    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                        <button mat-icon-button (click)="toggleLabourBreakdown()">
                            <mat-icon style="color:black;">{{ is_labour_breakdown_collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
                        </button>
                        <mat-card-title style="margin-left: 8px; flex: 1;">Labour Time</mat-card-title>
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="!is_labour_breakdown_collapsed">
                    <div style="display: flex; flex-direction: row; gap: 3em" *ngIf="productBreakdown.length > 0">
                        <div style="width: fit-content;">
                            <h3>Labour Breakdown by Product</h3>
                            <table [dataSource]="productBreakdown" mat-table>
                                <ng-container matColumnDef="product_description">
                                    <th mat-header-cell *matHeaderCellDef>Product Description</th>
                                    <td mat-cell *matCellDef="let element">{{element.product_description}}</td>
                                </ng-container>
                                <ng-container matColumnDef="product_class">
                                    <th mat-header-cell *matHeaderCellDef>Product Class</th>
                                    <td mat-cell *matCellDef="let element">{{element.product_class !== null ? element.product_class : 'no class found'}}</td>
                                </ng-container>
                                <ng-container matColumnDef="installation_min">
                                    <th mat-header-cell *matHeaderCellDef>Installation Time (Min)</th>
                                    <td mat-cell *matCellDef="let element">{{element.installation_min}}</td>
                                </ng-container>
                                <ng-container matColumnDef="installation_cost">
                                    <th mat-header-cell *matHeaderCellDef>Installation Cost</th>
                                    <td mat-cell *matCellDef="let element">{{element.installation_cost | number:'1.2-2'}}</td>
                                </ng-container>
                                <ng-container matColumnDef="installation_chargeable">
                                    <th mat-header-cell *matHeaderCellDef>Installation Chargeable</th>
                                    <td mat-cell *matCellDef="let element">{{element.installation_chargeable | number:'1.2-2'}}</td>
                                </ng-container>
                                <ng-container matColumnDef="handling_min">
                                    <th mat-header-cell *matHeaderCellDef>Handling Time (Min)</th>
                                    <td mat-cell *matCellDef="let element">{{element.handling_min}}</td>
                                </ng-container>
                                <ng-container matColumnDef="handling_cost">
                                    <th mat-header-cell *matHeaderCellDef>Handling Cost</th>
                                    <td mat-cell *matCellDef="let element">{{element.handling_cost | number:'1.2-2'}}</td>
                                </ng-container>
                                <ng-container matColumnDef="handling_chargeable">
                                    <th mat-header-cell *matHeaderCellDef>Handling Chargeable</th>
                                    <td mat-cell *matCellDef="let element">{{element.handling_chargeable | number:'1.2-2'}}</td>
                                </ng-container>
                                <tr class="header-row" mat-header-row *matHeaderRowDef="productBreakdownDisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: productBreakdownDisplayedColumns;"></tr>
                            </table>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div *ngIf="autorater_needed">
            <h2>Auto-rater</h2>
            <button mat-stroked-button [matMenuTriggerFor]="autoraterOptionsMenu" color="primary">Calculate</button>
            <mat-menu #autoraterOptionsMenu="matMenu">
                <button mat-menu-item *ngFor="let profile of contactProfiles" (click)="runAutoraterV2(profile['contact_profile_uuid'])">{{profile['profile_name']}}</button>
            </mat-menu>
            <div *ngIf="loading_autorater_results" class="spinner">
                <div class="lds-dual-ring"></div>
            </div>
            <div *ngIf="autorated_ladings_list.length > 0">
                <div class="autorater-results">
                    <h3>Results</h3>
                    <!-- <div style="display: flex; flex-direction: row; gap: 1em">
                        <div class="autorater-results" *ngFor="let lading of autorated_ladings_list; let i = index">
                            <h3>{{lading.alternate_reference}}</h3>
                            <div *ngIf="lading.warnings">
                                <h4>Warnings</h4>
                                <div *ngFor="let warning of lading.warnings" style="color:#940303">
                                    {{warning}}
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: column; gap: 3em">
                                <div class="table-container">
                                    <h4>Costs</h4>
                                    <ag-grid-angular
                                    class="ag-theme-ulaap"
                                    style="width: 100%;"
                                    domLayout="autoHeight"
                                    [rowData]="lading.financials.costs.line_items"
                                    [columnDefs]="raterColumnDefs"
                                    [pinnedBottomRowData]="getPinnedBottomRowDataFor(lading, 'costs')" 
                                    (cellValueChanged)="onCellValueChanged($event, i, lading, 'costs')"
                                    enableRowPinning>
                                    </ag-grid-angular>
                                </div>
                                <div class="table-container">
                                    <h4>Chargeables</h4>
                                    <ag-grid-angular
                                    class="ag-theme-ulaap"
                                    style="width: 100%;"
                                    domLayout="autoHeight"
                                    [rowData]="lading.financials.chargeables.line_items"
                                    [columnDefs]="raterColumnDefs"
                                    [pinnedBottomRowData]="getPinnedBottomRowDataFor(lading, 'chargeables')" 
                                    (cellValueChanged)="onCellValueChanged($event, i, lading, 'chargeables')"
                                    enableRowPinning>
                                    </ag-grid-angular>
                                </div>
                                <button mat-raised-button color="primary" (click)="postAutoraterCharges()">Save</button>
                            </div>
                        </div>
                    </div> -->
                    <div class="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden" *ngFor="let lading of autorated_ladings_list; let i = index">
                        <div class="bg-slate-800 text-white p-4 flex flex-col md:flex-row justify-between items-start md:items-center">
                            <div class="flex items-center gap-3 flex-wrap mb-1">
                                <div>
                                    <h2 class="text-xl font-bold flex items-center gap-2">
                                        <span class="text-blue-400">Ref:</span>
                                        <span>{{lading.alternate_reference || 'NO REF'}}</span>
                                    </h2>
                                    <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-indigo-500 text-white uppercase tracking-wider">B2B</span>
                                    <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-pink-500 text-white uppercase tracking-wider">B2C</span>
                                    <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-purple-500 text-white uppercase tracking-wider">Intercompany</span>
                                    <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-slate-600 text-slate-200 border border-slate-500 uppercase tracking-wider" x-text="'CH: ' + lading.metrics.distribution_channel"></span>
                                    <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-amber-500 text-amber-950 uppercase tracking-wider" x-text="lading.metrics.premium_rate"></span>
                                </div>
                                <div class="mt-4 md:mt-0 text-right bg-slate-700 px-4 py-2 rounded border border-slate-600"></div>
                                <p class="text-xs text-slate-300 uppercase tracking-wider font-semibold">Margin</p>
                                <p class="text-xl font-bold">
                                    $<span>0.00</span> 
                                    <span class="text-sm font-medium">(00.00%)</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <dialog #editLineItem mat-dialog *ngIf="isEditLineChargeOpen" style="display: flex">
            <h2 mat-dialog-title>Edit Service</h2>
            <div mat-dialog-content>
                <form [formGroup]="editLineChargeForm">
                    <mat-form-field>
                        <mat-label>Service Name</mat-label>
                        <input matInput formControlName="service" type="text">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Rate</mat-label>
                        <input matInput formControlName="rate" type="number">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Multiplier</mat-label>
                        <input matInput formControlName="rate_multiplier" type="number">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Net Amount</mat-label>
                        <input matInput formControlName="net_amount" type="number">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Note</mat-label>
                        <input matInput formControlName="note" type="text">
                    </mat-form-field>
                </form>
            </div>
            <div mat-dialog-actions>
                <button mat-button (click)="closeEditCharge()">Cancel</button>
                <button mat-raised-button (click)="saveCharge()">Save Services</button>
            </div>
        </dialog>

        <dialog #addService mat-dialog style="display:flex; flex-direction:column" *ngIf="isAddServiceOpen">
            <h2 mat-dialog-title>Add Service</h2>
            <div mat-dialog-content>
                <form [formGroup]="addServiceForm" style="display:flex; flex-direction:column">
                    <div>Please select charge type first.</div>
                    <mat-form-field>
                        <mat-label>Charge Type</mat-label>
                        <mat-select formControlName="charge_type" (selectionChange)="onSelectRateType($event)">
                            <mat-option *ngFor="let charge_type of chargeTypes; let i = index" [value]="i + 1">
                                {{charge_type}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- <mat-form-field>
                        <mat-label>Service Name</mat-label>
                        <mat-select formControlName="service">
                            <mat-option *ngFor="let service of serviceNames" [value]="service">{{service}}</mat-option>
                        </mat-select>
                    </mat-form-field> -->
                    <mat-form-field>
                        <mat-label>Service Name</mat-label>
                            <mat-select formControlName="service">
                                <mat-option>
                                    <ngx-mat-select-search 
                                        [formControl]="serviceFilterCtrl"
                                        placeholderLabel="Search services..."
                                        noEntriesFoundLabel="No matching services found">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let service of filteredServiceNames | async" [value]="service">{{service}}</mat-option>
                            </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Rate</mat-label>
                        <input matInput type="number" formControlName="rate">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Multiplier</mat-label>
                        <input matInput type="number" formControlName="multiplier">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Net Amount</mat-label>
                        <input matInput type="number" formControlName="net_amount">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Note</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="4" formControlName="note"></textarea>
                    </mat-form-field>
                </form>
            </div>
            <div mat-dialog-actions>
                <button mat-button (click)="closeAddService()">Cancel</button>
                <button mat-raised-button (click)="checkForExistingRate()">Check for Existing Rate</button>
                <button mat-raised-button (click)="saveNewService()">Save</button>
            </div>
        </dialog>

        <dialog #addMissingData mat-dialog style="display:flex; flex-direction:column" *ngIf="missing_data">
            <h2 mat-dialog-title>Add Missing Data</h2>
            <div mat-dialog-content>
                <form>
                    <div *ngFor="let group of missingDataControls; let i = index" [formGroup]="group">
                        <h3>{{group.get('alternate_reference')?.value}}</h3>
                        <mat-form-field *ngIf="group.get('carrier_name_query')">
                            <mat-label>Carrier Name</mat-label>
                            <input matInput formControlName="carrier_name_query" [matAutocomplete]="autoRef">
                            <mat-autocomplete #autoRef="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onContactSelected($event.option.value, i, 'carrier_contact_uuid')">
                                <mat-option *ngFor="let contact of filtered_contacts_list | async" [value]="contact">
                                    {{contact.label}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('customer_contact_uuid')">
                            <mat-label>Customer UUID</mat-label>
                            <input matInput formControlName="customer_contact_uuid">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('shipper_contact_uuid')">
                            <mat-label>Shipper UUID</mat-label>
                            <input matInput formControlName="shipper_contact_uuid">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('consignee_contact_uuid')">
                            <mat-label>Consignee UUID</mat-label>
                            <input matInput formControlName="consignee_contact_uuid">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('load_weight')">
                            <mat-label>Load Weight (lbs)</mat-label>
                            <input matInput formControlName="load_weight" type="number" min="0">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('load_start')">
                            <mat-label>Load Start (to get FSC)</mat-label>
                            <input matInput formControlName="load_start" type="date">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('shipper_locality')">
                            <mat-label>Shipper City/Town</mat-label>
                            <input matInput formControlName="shipper_locality">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('shipper_region')">
                            <mat-label>Shipper State/Province Abbreviation</mat-label>
                            <input matInput formControlName="shipper_region" maxlength="2">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('consignee_locality')">
                            <mat-label>Consignee City/Town</mat-label>
                            <input matInput formControlName="consignee_locality">
                        </mat-form-field>
                        <mat-form-field *ngIf="group.get('consignee_region')">
                            <mat-label>Consignee State/Province Abbreviation</mat-label>
                            <input matInput formControlName="consignee_region" maxlength="2">
                        </mat-form-field>
                    </div>
                </form>
            </div>
            <div mat-dialog-actions>
                <button mat-raised-button color="primary" (click)="onSubmitMissingData()">Calculate Rates</button>
                <button mat-button (click)="missing_data = false">Cancel</button>
            </div>
        </dialog>
    </div>
</ng-template>

<app-carrier-spot-quote
    *ngIf="showCarrierSpotQuoteModal" 
    [alternateReference]="lading_uuid"
    [isVisible]="showCarrierSpotQuoteModal" 
    class="modal" 
    (close)="closeCarrierSpotQuoteModal()" 
>

</app-carrier-spot-quote>

<ng-template #carrierEmailAddressDialog>
  <h2 mat-dialog-title>Carrier Email Address Not Found</h2>

  <mat-dialog-content>
    <div class="mat-dialog-content-wrapper"> 
        <div>Please enter the carrier's email address to send the confirmation to.</div>
        
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Carrier Email (Required)</mat-label>
            <input matInput 
                  type="email" 
                  placeholder="name@carrier.com" 
                  [formControl]="carrierEmailAddressControl" 
                  required>
            <mat-error *ngIf="carrierEmailAddressControl.errors?.['required'] && carrierEmailAddressControl.touched">
                Email is required.
            </mat-error>
            <mat-error *ngIf="carrierEmailAddressControl.errors?.['email'] && carrierEmailAddressControl.touched">
                Please enter a valid email address.
            </mat-error>
        </mat-form-field>
        
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Additional CC Emails (Comma Separated)</mat-label>
            <input matInput 
                  type="text" 
                  placeholder="colleague@email.com, partner@email.com" 
                  [formControl]="optionalCCControl">
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Additional BCC Emails (Comma Separated)</mat-label>
            <input matInput 
                  type="text" 
                  placeholder="boss@email.com" 
                  [formControl]="optionalBCCControl">
        </mat-form-field>
        
        <mat-checkbox 
            [(ngModel)]="sendCopyToggle">
            Send a copy to me
        </mat-checkbox>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="closeCarrierEmailAddressDialog()">Cancel</button>
    <button mat-flat-button 
            color="primary" 
            [disabled]="carrierEmailAddressControl.invalid" 
            (click)="sendCarrierConfirmationEmailWithAddressInput()">Submit</button>
  </mat-dialog-actions>
</ng-template>

<ng-container *ngIf="!hideMenu; else withoutMenu">
    <app-menu>
        <ng-container *ngTemplateOutlet="financialsContent"></ng-container>
    </app-menu>
</ng-container>

<ng-template #withoutMenu>
    <ng-container *ngTemplateOutlet="financialsContent"></ng-container>
</ng-template>
